export const QUERY_SOLUTION_LOCALE_ZHCHS = {
    saveAsDialog: {
        queryPlanName: 'æ¹æ¡åç§°',
        setAsDefault: 'è®¾ä¸ºé»è®¤',
        confirm: 'ç¡®å®',
        cancel: 'åæ¶',
        placeholder: 'è¯·è¾å¥æ¹æ¡åç§°',
        pleaseInput: 'è¯·è¾å¥æ¹æ¡åç§°',
        title: 'æ°å¢æ¹æ¡',
        maxLength: 'æ¹æ¡åç§°è¶åºä¹ä¸ªå­'
    },
    manageDialog: {
        name: 'åç§°',
        property: 'å±æ§',
        default: 'é»è®¤',
        operation: 'æä½',
        confirm: 'ç¡®å®',
        cancel: 'åæ¶',
        planNameDuplicated: 'æ¹æ¡åç§°{0}éå¤',
        system: 'ç³»ç»',
        personal: 'ä¸ªäºº'
    },
    container: {
        default: 'é»è®¤',
        manage: 'ç®¡ç',
        arrowUp: 'æ¶èµ·',
        arrowDown: 'å±å¼',
        saveAs: 'å¦å­ä¸ºæ¹æ¡',
        empty: 'ç©º',
        save: 'ä¿å­æ¹æ¡',
        pleaseInput: 'formIdä¸ºå¿ä¼ å­æ®µï¼è¯·ä¼ å¥',
        saveSuccess: 'æ¥è¯¢æ¹æ¡ä¿å­æå',
        saveFail: 'æ¥è¯¢æ¹æ¡ä¿å­å¤±è´¥',
        planManage: 'æ¹æ¡ç®¡ç',
        clear: 'æ¸ç©º',
        require: 'è¯·å¡«å{fields}åè¿è¡ç­é',
        defaultName: 'é»è®¤ç­éæ¹æ¡',
        histroyName: 'ä¸æ¬¡ç­é',
        sysPresetName: 'ç³»ç»é¢ç½®æ¹æ¡'
    }

};
